
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hB2SF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "AttachmentGridView", () => $3750f5d7438feb32$export$5ab37d40c5d5b3c9);
$parcel$export(module.exports, "default", () => $3750f5d7438feb32$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $lFKmC = parcelRequire("lFKmC");

var $8k5Wk = parcelRequire("8k5Wk");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6M6vE = parcelRequire("6M6vE");

var $7qyDl = parcelRequire("7qyDl");

var $dfJ3P = parcelRequire("dfJ3P");

var $2gCtH = parcelRequire("2gCtH");

var $dPP9r = parcelRequire("dPP9r");

var $hxqfC = parcelRequire("hxqfC");

var $eV94v = parcelRequire("eV94v");

var $iowjP = parcelRequire("iowjP");

var $8wXP2 = parcelRequire("8wXP2");

var $dJq4H = parcelRequire("dJq4H");

var $a1ky2 = parcelRequire("a1ky2");

var $bcoYn = parcelRequire("bcoYn");

var $gDpUM = parcelRequire("gDpUM");

var $2HbP2 = parcelRequire("2HbP2");

var $93Yeu = parcelRequire("93Yeu");

var $17Gip = parcelRequire("17Gip");

var $gqJ3C = parcelRequire("gqJ3C");

var $8G097 = parcelRequire("8G097");

var $fyfDQ = parcelRequire("fyfDQ");

var $kAwig = parcelRequire("kAwig");

var $7GvHY = parcelRequire("7GvHY");

var $9Qvrl = parcelRequire("9Qvrl");
const $3750f5d7438feb32$var$AttachmentGridViewInternal = (props)=>{
    const intl = (0, $koVbs.default)();
    const { updateTotalItems: updateTotalItems, gridSize: gridSize, startIndex: startIndex } = (0, $7GvHY.useGridContext)();
    const isFirstRender = (0, $5uXOq.useRef)(true);
    const { isMobile: isMobile, isPreview: isPreview, mediaContext: mediaContext, onScrollToComments: onScrollToComments, onScrollToWorklogs: onScrollToWorklogs, viewMediaClientConfig: viewMediaClientConfig } = props;
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const shouldEnableDownloadButton = (0, $17Gip.useCanDownloadAttachments)(projectKey);
    const [isFetching] = (0, $gqJ3C.useAttachmentStoreIsFetching)(issueKey);
    const [{ value: { attachments: attachments = [], totalCount: totalCount }, error: error }, { refreshAttachments: refreshAttachments }] = (0, $7qyDl.useIssueAttachments)(issueKey, {
        maxResults: gridSize
    });
    const canDeleteAttachmentMapModal = (0, $6M6vE.useCanDeleteAttachment)();
    const items = (0, $5uXOq.useMemo)(()=>attachments.map((attachment)=>{
            const identifier = {
                mediaItemType: 'file',
                id: attachment.mediaApiFileId,
                attachmentId: attachment.id,
                ...mediaContext.viewContext && mediaContext.viewContext.collection !== null ? {
                    collectionName: mediaContext.viewContext.collection
                } : {}
            };
            const actions = (0, $8G097.getActionsForAttachment)(attachment.id, attachment.parentName, attachment.parentId, canDeleteAttachmentMapModal[attachment.id], intl, issueKey, onScrollToComments, onScrollToWorklogs);
            return {
                identifier: identifier,
                selectable: false,
                actions: actions,
                isLazy: !isMobile,
                isPreview: isPreview,
                hasRestrictedParent: attachment.hasRestrictedParent
            };
        }), [
        attachments,
        intl,
        isMobile,
        issueKey,
        mediaContext.viewContext,
        onScrollToComments,
        onScrollToWorklogs,
        canDeleteAttachmentMapModal,
        isPreview
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRefreshAttachments = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(refreshAttachments, (0, $9Qvrl.DEBOUNCE_DURATION)), [
        refreshAttachments
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        refreshAttachments(issueKey, {
            startAt: startIndex,
            maxResults: gridSize
        });
    }, [
        issueKey,
        refreshAttachments,
        startIndex,
        gridSize
    ]);
    /**
   * Refresh attachments only on first render.
   *
   * There is a issue with the attachments service, that it doesn't refetch
   * attachments using `useIssueAttachments` hook when totalCount is available.
   * This is a workaround to refresh attachments when the component is mounted
   * and totalCount is available.
   */ (0, $5uXOq.useEffect)(()=>{
        if (isFirstRender.current && totalCount !== undefined && !isFetching) {
            refreshAttachments(issueKey, {
                startAt: startIndex,
                maxResults: gridSize
            });
            isFirstRender.current = false;
        }
    }, [
        issueKey,
        refreshAttachments,
        startIndex,
        gridSize,
        totalCount,
        isFetching
    ]);
    // Refresh attachments when there is a changes ingrid size of page number
    (0, $5uXOq.useEffect)(()=>{
        debouncedRefreshAttachments(issueKey, {
            startAt: startIndex,
            maxResults: gridSize
        });
    }, [
        issueKey,
        debouncedRefreshAttachments,
        startIndex,
        gridSize
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateTotalItems(totalCount);
    }, [
        updateTotalItems,
        totalCount
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dfJ3P.default), {
        shouldHideImage: true,
        onClick: onClick
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fyfDQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kAwig.default), {
        items: items,
        mediaClientConfig: viewMediaClientConfig,
        shouldEnableDownloadButton: shouldEnableDownloadButton
    })));
};
const $3750f5d7438feb32$export$5ab37d40c5d5b3c9 = (props)=>{
    const { viewMediaClientConfig: viewMediaClientConfig } = props;
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const shouldEnableDownloadButton = (0, $17Gip.useCanDownloadAttachments)(projectKey);
    const mediaClientConfig = (0, $5uXOq.useMemo)(()=>({
            ...viewMediaClientConfig,
            enforceDataSecurityPolicy: (0, $4R6GH.fg)('block_attachment_download_on_data_export_dsp_rule') && !shouldEnableDownloadButton
        }), [
        shouldEnableDownloadButton,
        viewMediaClientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8k5Wk.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3750f5d7438feb32$var$AttachmentGridViewInternal, {
            ...props,
            viewMediaClientConfig: mediaClientConfig
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8k5Wk.MediaClientProvider), {
            clientConfig: mediaClientConfig
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3750f5d7438feb32$var$AttachmentGridViewInternal, {
            ...props,
            viewMediaClientConfig: mediaClientConfig
        })));
};
const $3750f5d7438feb32$var$AttachmentGridViewConnect = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $dPP9r.default), (0, $hxqfC.connect)((state)=>({
        mediaContext: (0, $gDpUM.mediaContextSelector)(state),
        isMobile: (0, $a1ky2.isMobileSelector)(state),
        isPreview: (0, $bcoYn.isPreviewSelector)(state)
    }), (dispatch)=>({
        onCardCoverShow: (currentAttachmentId, newAttachmentId)=>{
            dispatch((0, $eV94v.cardCoverUpdateRequest)(currentAttachmentId, newAttachmentId));
        },
        onCardCoverHide: (currentAttachmentId)=>{
            dispatch((0, $eV94v.cardCoverUpdateRequest)(currentAttachmentId));
        },
        onScrollToComments: ()=>{
            dispatch((0, $iowjP.scrollToAttachmentComment)());
        },
        onScrollToWorklogs: ()=>{
            dispatch((0, $iowjP.scrollToAttachmentWorklog)());
        },
        onViewRefresh: ()=>{
            dispatch((0, $dJq4H.fetchViewContextRequest)());
        },
        onUploadRefresh: ()=>{
            dispatch((0, $8wXP2.fetchUploadContextRequest)());
        }
    })))($3750f5d7438feb32$export$5ab37d40c5d5b3c9);
var $3750f5d7438feb32$export$2e2bcd8739ae039 = $3750f5d7438feb32$var$AttachmentGridViewConnect;

});
parcelRegister("kAwig", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9a3e6f137cc2ba5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hCfTW = parcelRequire("hCfTW");
var $2qiW1 = parcelRequire("2qiW1");

var $cIc7U = parcelRequire("cIc7U");

var $4R6GH = parcelRequire("4R6GH");

var $4h3hM = parcelRequire("4h3hM");

var $9Qvrl = parcelRequire("9Qvrl");
const $c9a3e6f137cc2ba5$var$cardDimensions = {
    width: '100%',
    height: (0, $9Qvrl.GRID_ITEM_DIMENSIONS).height
};
const $c9a3e6f137cc2ba5$var$MediaCardItems = ({ items: items, mediaClientConfig: mediaClientConfig, shouldEnableDownloadButton: shouldEnableDownloadButton })=>{
    const attachmentIdentifiers = items.map((item)=>item.identifier);
    return items.map((item)=>{
        const isInternalAttachment = item.hasRestrictedParent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCfTW.default), {
            xcss: $c9a3e6f137cc2ba5$var$mediaCardStyle,
            key: item.identifier.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cIc7U.default), {
            mediaClientConfig: mediaClientConfig,
            mediaViewerItems: attachmentIdentifiers,
            useInlinePlayer: false,
            shouldOpenMediaViewer: true,
            dimensions: $c9a3e6f137cc2ba5$var$cardDimensions,
            featureFlags: (0, $4h3hM.mediaFeatureFlags)(),
            titleBoxBgColor: isInternalAttachment ? "var(--ds-background-accent-purple-subtle, #9F8FEF)" : undefined,
            titleBoxIcon: isInternalAttachment ? 'LockFilledIcon' : undefined,
            shouldEnableDownloadButton: !(0, $4R6GH.fg)('block_attachment_download_on_data_export_dsp_rule') || shouldEnableDownloadButton,
            ...item,
            testId: `issue.views.issue-base.content.attachment.grid-view.attachment-id.${item.identifier.attachmentId}`
        }));
    });
};
const $c9a3e6f137cc2ba5$var$mediaCardStyle = (0, $2qiW1.xcss)({
    // https://hello.atlassian.net/wiki/spaces/DST/pages/3225764567/Guide+for+Migrating+to+Spacing+Tokens#The-value-I%E2%80%99m-migrating-is-too-large-to-be-represented-with-a-token
    minWidth: '132px',
    width: '100%',
    height: '125px',
    cursor: 'pointer'
});
var $c9a3e6f137cc2ba5$export$2e2bcd8739ae039 = $c9a3e6f137cc2ba5$var$MediaCardItems;

});



//# sourceMappingURL=async-attachment-grid-view.e23fad18.js.map
